export default "__VITE_ASSET__DFbLvkAQ__"